/* eslint-disable @next/next/no-img-element */
import { FC, memo } from 'react'

import styles from './UploadPlaceholder.module.scss'

import { UploadPlaceholderComponentProps } from '~lib/editor/extensions/media/insertMedia'
import Loader from '~lib/ui-kit/Loader'
import { isVideo } from '~lib/utils/files'

const UploadPlaceholder: FC<React.PropsWithChildren<UploadPlaceholderComponentProps>> = ({ file }) => {
  return (
    <div className={styles.root} contentEditable="false">
      <div className={styles.inner}>
        <span className={styles.spinnerContainer}>
          <Loader />
        </span>
        {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
        {isVideo(file) ? <video src={URL.createObjectURL(file)} /> : <img alt="" src={URL.createObjectURL(file)} />}
      </div>
    </div>
  )
}

export default memo(UploadPlaceholder)
